export class CheckFeasibilityRequest {
  coordinates: {
    type: string;
    coordinates: number[];
  };
  label: string;
  id: number;
  type: string;
  comune: string;
  cap: number;
  provincia: string;
  street: string;
  street_number: number;
  research_method: string;
  pop?: string;
  civico?: string;
  interest_point?: boolean;
  access_type?: string;
  id_building?: string;
  is_editable?: boolean;
  anno_bando?: string;

  constructor(model?: any) {
    this.coordinates = model.coordinates;
    this.label = model.label;
    this.id = model.id;
    this.type = model.type;
    this.comune = model.comune;
    this.cap = model.cap;
    this.provincia = model.provincia;
    this.street = model.street;
    this.street_number = model.street_number;
    this.research_method = model.research_method;
    this.civico = model.civico;
    this.interest_point = model.interest_point;
    this.pop = model.pop;
    this.access_type =  model.access_type;
    this.id_building = model.id_building;
    this.is_editable = model.is_editable;
    this.anno_bando = model.anno_bando;
  }
}

export class SingleRequest {
    access_type: string;
    p1_id: number;
    p1_type: string;
    p1_pop?: number;
    p1_interest_point: boolean;
    p1_civico?: number;
    p1_comune?: string;
    p1_cap: number;
    p1_provincia: string;
    p1_label: string;
    p1_coordinate: {
        type: string;
        coordinates: any
    };
    p1_research_method: string;
    p1_coordinates_type?: string;
    p1_country: string;
    street?: string;
    civic_number?: string;
    type?: string
    p1_anno_bando?: string;
}

export class MultipleRequest {
}
